<template>
  <Layout>
    <FirstSection />
    <FeaturedVideos />
    <AlertSection />
    <SecondSection id="main" />
    <ThirdSection />
    <SectionsSection />
    <DemosSection />
    <SpeakersSection />
    <PartnersSection id="partners" />
  </Layout>
</template>

<script>
import Layout from '@/layouts/HomeLayout'
import FirstSection from '@/components/HomeFirstSection'
import FeaturedVideos from '@/components/HomeFeaturedVideos'
import AlertSection from '@/components/HomeAlertSection'
import SecondSection from '@/components/HomeSecondSection'
import ThirdSection from '@/components/HomeThirdSection'
import SectionsSection from '@/components/HomeSectionsSection'
import DemosSection from '@/components/HomeDemosSection'
import SpeakersSection from '@/components/HomeSpeakersSection'
import PartnersSection from '@/components/HomePartnersSection'

export default {
  components: {
    Layout,
    FirstSection,
    FeaturedVideos,
    AlertSection,
    SecondSection,
    ThirdSection,
    SectionsSection,
    DemosSection,
    SpeakersSection,
    PartnersSection,
  },

  mounted() {
    this.$store.dispatch('home/fetchHomeContents').then(video => {
      this.$store.commit('videos/setVideo', video)
    })
  },
}
</script>

<style scoped>
>>> h2 {
  @apply text-3xl mb-8;
}

@screen sm {
  >>> h2 {
    @apply text-5xl;
  }
}
</style>
